/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './MailLogin.scss';
import { ScaleLoader } from 'react-spinners';
import { withTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import SetPwdService from '../../core/service/SetPwdService';
import CommonService, { COMPLETED_TXT, ONBOARD_TXT, PASSWORD_SET_TXT, SUPPLIER_DETAILS_TXT } from '../../core/service/CommonService';
import { LS_AUTHORITY_KEY } from '../../core/constants/common';
import { hasGoalsKpiNavAccess } from '../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess';
import { buildHierarchyPermissions } from '../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions';

const MailLogin = ({ t }) => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const userDataLS = localStorage.getItem('userOnboardData');
  let [color, setColor] = useState("#383cc1");
  const { invite_key } = useParams();
  useEffect(() => {
    verifyInvitation(invite_key);
  });

  const verifyInvitation = (key) => {
    SetPwdService.verifyInvitation(key)
      .then((response) => {
        var nextStep = response.data.nextStep;
        switch (nextStep) {
          case null:
          case COMPLETED_TXT: if (accessToken) {
            const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || 'null');
            // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
            if (hasGoalsKpiNavAccess(buildHierarchyPermissions(Array.isArray(lsDat?.roles) ? lsDat.roles : []))) {
              navigate("/company_admin/goals_kpi/dashboard");
            } else {
              navigate("/company_admin/");
            }
          } else {
            goLogin();
          }          
            break;
          case ONBOARD_TXT: if (accessToken) {
            if(CommonService.checkValidValue(userDataLS)) {
              var parsedDat = JSON.parse(userDataLS);
              navigate("/company_admin/company_onboard/" + parsedDat.key);
            } else {
              goLogin();
            }
            
          } else {
            goLogin();
          }
            break;
          case SUPPLIER_DETAILS_TXT: if (accessToken) {
            if(CommonService.checkValidValue(userDataLS)) {
              var parsedDat = JSON.parse(userDataLS);            
              navigate("/company_admin/supplier_details_onboard/" + parsedDat.connectedCompany.companyId + "/" + parsedDat.connectedCompany.supplierDetails.id);
            } else {
              goLogin();
            }
          } else {
            goLogin();
          }
            break;
          case PASSWORD_SET_TXT: navigate("/set_password/" + invite_key);
            break;
          default: goLogin();
            break;
        }
      })
      .catch((error) => {
        console.log("err", error);
      });
  };

  const goLogin = () => {
    navigate("/login");
  };

  return (
    <div className="loader-custom">
      <ScaleLoader color={color} loading={true} size={25} />
    </div>
  )
};

export default withTranslation()(MailLogin);
